import { Repeater, types } from "react-bricks/frontend"

import DividerPanel from "../divider-panel"
import React from "react"
import SectionHeader from "../section-header"
import { useTranslation } from "react-i18next"

const Faqs: types.Brick = () => {
    const { t } = useTranslation("translations")

    return (
        <section>
            <SectionHeader title={t("faq_title")} icon="f" />
            <DividerPanel />
            <div>
                <Repeater propName="repeater" />
            </div>
        </section>
    )
}

Faqs.schema = {
    name: "FAQs",
    label: "FAQs",
    repeaterItems: [
        {
            name: "repeater",
            items: [
                {
                    type: "FAQ",
                    label: "FAQ",
                    min: 1,
                },
            ],
        },
    ],
}

export default Faqs
